import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlockScreenComponent } from './block-screen.component';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    BlockScreenComponent
  ],
  declarations: [
    BlockScreenComponent
  ],
  providers: []
})
export class BlockScreenModule { }
